import EventsApi from "../../../api/events-api";

const initialState = () => ({
    isFetching: false,
    actualSummary: {},
    actualEvents: [],
    futureEvents: [],
    data: [],
    stateID: null
});

const actions = {
    getEvents: async ({ commit }, payload) => {
        const { summarize, cowIDs, stateIDs, rowsPerPage, statuses, fromDashboard, validOnly } = payload || {};
        try {
            commit("request", payload);
            const apiResponse = await EventsApi.get(
                cowIDs, stateIDs, rowsPerPage,
                statuses, fromDashboard, validOnly
            );
            if (apiResponse && apiResponse.data) {
                commit(`getEventsSuccess`, apiResponse.data);

                if (summarize) {
                    commit("actualSummarize");
                }

            } else {
                commit("getEventsFailed", apiResponse);
            }
        } catch (e) {
            commit("getEventsFailed", e);
        }
    },

    clear: ({ commit }) => {
        commit("clear", initialState());
    }
};

// mutations
const mutations = {
    request: (state, payload) => {
        state.isFetching = true;
        state.stateID = payload.stateID;
    },
    actualSummarize: state => {
        const summary = {};
        state.actualEvents.forEach(element => {
            if (!summary[element.stateID]) {
                summary[element.stateID] = 1;
            } else {
                summary[element.stateID] += 1;
            }
        });
        state.actualSummary = summary;
    },
    getEventsSuccess: (state, payload) => {
        state.isFetching = false;

        const [actualEvents, futureEvents] = payload.data.reduce(
            ([at, ft], event) =>
                (event.validFrom
                    ? new Date(event.validFrom).valueOf() < new Date().valueOf()
                    : true)
                    ? [[...at, event], ft]
                    : [at, [...ft, event]],
            [[], []]
        );

        state['actualEvents'] = actualEvents;
        state['futureEvents'] = futureEvents;
    },
    getEventsFailed: state => {
        state.isFetching = false;
    },
    clear: (state, initialState) => {
        Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
        });
    }
};

export default {
    namespaced: true,
    state: initialState(),
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/plugins/store/modules/events.js